import script from "./VoiceToTextButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoiceToTextButton.vue?vue&type=script&setup=true&lang=ts"

import "./VoiceToTextButton.vue?vue&type=style&index=0&id=027e3bc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027e3bc8"]])

export default __exports__